import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    
    html, body, #root {
        background-color: ${(props) => props.theme.colors.gray1};
        height: 100vh;
        font-size: 16px;
    }

    // Customized scrollbar
    ::-webkit-scrollbar {
        width: 0.5rem;
        height: 0;
    }

    ::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.colors.gray1}; 
    }
    
    ::-webkit-scrollbar-thumb {
        width: 100%;
        height: 8rem;
        top: 0px;
        left: 0px;
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 6.18rem;
        user-select: none;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.6);
    }
    //
`;
